const mapOptions = () => {
  return {
    disableDefaultUI: false,
    clickableIcons: false,
    fullscreenControl: false,
    gestureHandling: 'greedy',
    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    styles: [
      {
        featureType: 'administrative',
        elementType: 'geometry',
        stylers: [
          {
            color: '#96adfa'
          },
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'administrative.country',
        elementType: 'all',
        stylers: [
          {
            color: '#7a749c'
          }
        ]
      },
      {
        featureType: 'administrative.country',
        elementType: 'labels',
        stylers: [
          {
            color: '#635d8c'
          }
        ]
      },
      {
        featureType: 'administrative.country',
        elementType: 'labels.text',
        stylers: [
          {
            weight: '0.01'
          },
          {
            saturation: '0'
          },
          {
            color: '#48477a'
          }
        ]
      },
      {
        featureType: 'administrative.province',
        elementType: 'all',
        stylers: [
          {
            color: '#48477a'
          },
          {
            weight: '0.01'
          },
          {
            visibility: 'on'
          }
        ]
      },
      {
        featureType: 'administrative.locality',
        elementType: 'all',
        stylers: [
          {
            color: '#48477a'
          },
          {
            weight: '0.01'
          }
        ]
      },
      {
        featureType: 'administrative.neighborhood',
        elementType: 'all',
        stylers: [
          {
            color: '#787687'
          },
          {
            weight: '0.01'
          }
        ]
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'all',
        stylers: [
          {
            color: '#787687'
          },
          {
            weight: '0.01'
          }
        ]
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'geometry',
        stylers: [
          {
            color: '#96adfa'
          }
        ]
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
          {
            saturation: -84
          },
          {
            lightness: 59
          },
          {
            visibility: 'on'
          },
          {
            color: '#F7F7FE'
          }
        ]
      },
      {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [
          {
            hue: '#ff0000'
          },
          {
            saturation: -100
          },
          {
            lightness: 100
          },
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'administrative.country',
        elementType: 'geometry.stroke',
        stylers: [
          {
            visibility: 'on'
          },
          {
            color: '#bcbace'
          }
        ]
      },
      {
        featureType: 'landscape.man_made',
        elementType: 'geometry',
        stylers: [
          {
            color: '#21175a'
          },
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
          {
            visibility: 'on'
          }
        ]
      },
      {
        featureType: 'poi.park',
        elementType: 'all',
        stylers: [
          {
            visibility: 'on'
          },
          {
            color: '#00c4ac'
          },
          {
            weight: '0.01'
          }
        ]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            saturation: 1
          },
          {
            lightness: -15
          },
          {
            visibility: 'on'
          },
          {
            color: '#ccf3ef'
          }
        ]
      },
      {
        featureType: 'poi.school',
        elementType: 'all',
        stylers: [
          {
            hue: '#d7e4e4'
          },
          {
            saturation: -60
          },
          {
            lightness: 23
          },
          {
            visibility: 'on'
          }
        ]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            hue: '#ff0000'
          },
          {
            saturation: -100
          },
          {
            lightness: 100
          },
          {
            visibility: 'on'
          }
        ]
      },
      {
        featureType: 'road.local',
        elementType: 'geometry.stroke',
        stylers: [
          {
            visibility: 'on'
          },
          {
            color: '#E5E5FF'
          }
        ]
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry.stroke',
        stylers: [
          {
            visibility: 'on'
          },
          {
            color: '#E5E5FF'
          }
        ]
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            saturation: 100
          },
          {
            lightness: -22
          },
          {
            visibility: 'on'
          },
          {
            color: '#D2D1D7'
          }
        ]
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text',
        stylers: [
          {
            color: '#BCBACE'
          }
        ]
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
          {
            saturation: 100
          },
          {
            lightness: -35
          },
          {
            visibility: 'simplified'
          },
          {
            color: '#fff0cb'
          }
        ]
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off'
          }
        ]
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text',
        stylers: [
          {
            visibility: 'on'
          },
          {
            color: '#BCBACE'
          },
          {
            weight: '0.01'
          }
        ]
      },

      {
        featureType: 'water',
        elementType: 'all',
        stylers: [
          {
            saturation: 55
          },
          {
            lightness: -8
          },
          {
            visibility: 'on'
          }
        ]
      },
      {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#DCE4FD'
          },
          {
            saturation: '-10'
          }
        ]
      },
      {
        featureType: 'water',
        elementType: 'labels.text',
        stylers: [
          {
            visibility: 'on'
          },
          {
            color: '#9896FF'
          }
        ]
      }
    ]
  };
};

export default mapOptions;
